export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  categoryId: string;
  coverImage: string;
  description: string;
  rating: number;
  views: number;
  chapters: Chapter[];
  status: '连载中' | '已完结';
  updateDate: string;
  tags: string[];
}

export interface Chapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
  views: number;
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { id: 'all', name: '全部', icon: 'ri-apps-line', count: 120 },
  { id: 'romance', name: '恋爱', icon: 'ri-heart-line', count: 35 },
  { id: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 28 },
  { id: 'action', name: '动作', icon: 'ri-sword-line', count: 22 },
  { id: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', count: 15 },
  { id: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 18 },
  { id: 'drama', name: '剧情', icon: 'ri-film-line', count: 25 },
  { id: 'bl', name: '耽美', icon: 'ri-star-line', count: 20 },
];

export const hotComics: Comic[] = [
  {
    id: 'comic-1',
    title: '她的私密世界',
    author: '金智恩',
    category: '恋爱',
    categoryId: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20cover%20art%2C%20beautiful%20young%20woman%20with%20flowing%20hair%20looking%20at%20viewer%2C%20soft%20pastel%20pink%20and%20peach%20color%20palette%2C%20minimal%20composition%2C%20clean%20lines%2C%20manhwa%20style%20illustration%2C%20delicate%20facial%20features%2C%20dreamy%20atmosphere%2C%20simple%20gradient%20background%2C%20digital%20art%2C%20high%20quality%20render&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '普通上班族林小雨意外发现自己能够进入别人的梦境之中。在一次偶然的梦境穿越中，她闯入了公司冷面上司的梦里，却发现了一个完全不同的他……一场跨越现实与梦境的浪漫爱情故事就此展开。',
    rating: 4.8,
    views: 1250000,
    chapters: [
      { id: 'ch1-1', title: '第1话：意外的闯入', number: 1, updateDate: '2026-08-01', views: 85000 },
      { id: 'ch1-2', title: '第2话：梦中的他', number: 2, updateDate: '2026-08-02', views: 82000 },
      { id: 'ch1-3', title: '第3话：无法逃避', number: 3, updateDate: '2026-08-03', views: 79000 },
      { id: 'ch1-4', title: '第4话：心动的瞬间', number: 4, updateDate: '2026-08-04', views: 76000 },
      { id: 'ch1-5', title: '第5话：告白', number: 5, updateDate: '2026-08-05', views: 72000 },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
    tags: ['恋爱', '奇幻', '办公室', '甜宠'],
  },
  {
    id: 'comic-2',
    title: '剑与魔法之诗',
    author: '朴俊秀',
    category: '奇幻',
    categoryId: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20cover%20art%2C%20male%20warrior%20holding%20a%20glowing%20magical%20sword%2C%20epic%20atmosphere%2C%20dark%20blue%20and%20silver%20color%20scheme%2C%20dramatic%20lighting%2C%20manhwa%20style%20illustration%2C%20detailed%20armor%2C%20mystical%20energy%20effects%2C%20simple%20dark%20gradient%20background%2C%20digital%20art%2C%20high%20quality%20render&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '在一个剑与魔法共存的世界里，平凡的少年艾伦意外获得了传说中的圣剑。他必须踏上冒险之旅，集结伙伴，对抗即将降临的黑暗势力。这是一部关于勇气、友情与成长的史诗奇幻故事。',
    rating: 4.9,
    views: 2100000,
    chapters: [
      { id: 'ch2-1', title: '第1话：圣剑觉醒', number: 1, updateDate: '2026-07-28', views: 120000 },
      { id: 'ch2-2', title: '第2话：踏上旅途', number: 2, updateDate: '2026-07-30', views: 115000 },
      { id: 'ch2-3', title: '第3话：伙伴集结', number: 3, updateDate: '2026-08-01', views: 108000 },
    ],
    status: '连载中',
    updateDate: '2026-08-01',
    tags: ['奇幻', '冒险', '战斗', '成长'],
  },
  {
    id: 'comic-3',
    title: '暗夜追踪者',
    author: '李在勋',
    category: '悬疑',
    categoryId: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20thriller%20cover%20art%2C%20detective%20in%20trench%20coat%20standing%20in%20rainy%20alley%2C%20noir%20atmosphere%2C%20dark%20gray%20and%20crimson%20accents%2C%20moody%20lighting%2C%20manhwa%20style%20illustration%2C%20mysterious%20vibe%2C%20urban%20night%20scene%2C%20simple%20dark%20gradient%20background%2C%20digital%20art%2C%20high%20quality%20render&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '首尔夜晚的街头，一连串离奇失踪案让整座城市陷入恐慌。前刑警姜泰浩被卷入其中，在追踪真相的过程中，他发现自己面对的不仅是罪犯，还有一个隐藏在都市阴影中的巨大阴谋。',
    rating: 4.7,
    views: 980000,
    chapters: [
      { id: 'ch3-1', title: '第1话：消失的人们', number: 1, updateDate: '2026-07-25', views: 65000 },
      { id: 'ch3-2', title: '第2话：第一个线索', number: 2, updateDate: '2026-07-27', views: 62000 },
    ],
    status: '连载中',
    updateDate: '2026-07-27',
    tags: ['悬疑', '犯罪', '推理', '都市'],
  },
  {
    id: 'comic-4',
    title: '隔壁的妖精',
    author: '崔秀妍',
    category: '搞笑',
    categoryId: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20comedy%20cover%20art%2C%20cute%20girl%20with%20exaggerated%20funny%20expression%2C%20bright%20yellow%20and%20orange%20color%20palette%2C%20cheerful%20atmosphere%2C%20manhwa%20chibi%20style%2C%20playful%20composition%2C%20simple%20warm%20gradient%20background%2C%20digital%20art%2C%20high%20quality%20render&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '大学生韩智浩搬进新公寓后，发现隔壁住着一个自称是"修炼了五百年的妖精"的奇怪女孩。她不懂人间烟火，闹出了无数笑话。一部让人捧腹大笑的日常喜剧！',
    rating: 4.6,
    views: 1560000,
    chapters: [
      { id: 'ch4-1', title: '第1话：新邻居', number: 1, updateDate: '2026-07-20', views: 95000 },
      { id: 'ch4-2', title: '第2话：妖精的早餐', number: 2, updateDate: '2026-07-22', views: 92000 },
      { id: 'ch4-3', title: '第3话：人间修炼', number: 3, updateDate: '2026-07-24', views: 88000 },
    ],
    status: '连载中',
    updateDate: '2026-07-24',
    tags: ['搞笑', '日常', '奇幻', '轻松'],
  },
  {
    id: 'comic-5',
    title: '重生之商业帝国',
    author: '郑民浩',
    category: '剧情',
    categoryId: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20drama%20cover%20art%2C%20confident%20businessman%20in%20suit%20looking%20over%20city%20skyline%2C%20sophisticated%20navy%20and%20gold%20color%20scheme%2C%20professional%20atmosphere%2C%20manhwa%20style%20illustration%2C%20modern%20office%20setting%2C%20simple%20gradient%20background%2C%20digital%20art%2C%20high%20quality%20render&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '被最信任的伙伴背叛而死的商业天才林振宇，带着前世的记忆重生回到了二十年前。这一次，他要用自己的知识和经验，在这个世界建立起属于自己的商业帝国，并向那些背叛者复仇。',
    rating: 4.9,
    views: 1850000,
    chapters: [
      { id: 'ch5-1', title: '第1话：死亡与重生', number: 1, updateDate: '2026-07-15', views: 150000 },
      { id: 'ch5-2', title: '第2话：回到1998', number: 2, updateDate: '2026-07-17', views: 145000 },
      { id: 'ch5-3', title: '第3话：第一桶金', number: 3, updateDate: '2026-07-19', views: 140000 },
      { id: 'ch5-4', title: '第4话：布局', number: 4, updateDate: '2026-07-21', views: 135000 },
    ],
    status: '连载中',
    updateDate: '2026-07-21',
    tags: ['剧情', '重生', '商战', '复仇'],
  },
  {
    id: 'comic-6',
    title: '霸道总裁的契约新娘',
    author: '宋慧琳',
    category: '恋爱',
    categoryId: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20cover%20art%2C%20elegant%20couple%20in%20formal%20attire%20facing%20each%20other%2C%20luxurious%20ballroom%20setting%2C%20rose%20gold%20and%20cream%20color%20palette%2C%20romantic%20atmosphere%2C%20manhwa%20style%20illustration%2C%20soft%20lighting%2C%20simple%20warm%20gradient%20background%2C%20digital%20art%2C%20high%20quality%20render&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '为了拯救家族企业，苏婉清不得不与冷酷霸道的总裁顾北辰签订了一份契约婚姻。她以为这只是一场交易，却没想到在这个过程中，两颗心正在慢慢靠近……',
    rating: 4.7,
    views: 1680000,
    chapters: [
      { id: 'ch6-1', title: '第1话：命运的交易', number: 1, updateDate: '2026-07-10', views: 130000 },
      { id: 'ch6-2', title: '第2话：契约生效', number: 2, updateDate: '2026-07-12', views: 125000 },
    ],
    status: '连载中',
    updateDate: '2026-07-12',
    tags: ['恋爱', '总裁', '契约婚姻', '甜宠'],
  },
];

export const latestUpdates: Comic[] = [
  {
    id: 'comic-7',
    title: '末日生存手册',
    author: '韩志勋',
    category: '动作',
    categoryId: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20cover%20art%2C%20survivor%20with%20weapon%20in%20post%20apocalyptic%20city%2C%20intense%20red%20and%20dark%20gray%20color%20scheme%2C%20dramatic%20action%20pose%2C%20manhwa%20style%20illustration%2C%20ruined%20urban%20landscape%2C%20simple%20dark%20gradient%20background%2C%20digital%20art%2C%20high%20quality%20render&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '一场突如其来的病毒让世界陷入混乱。普通大学生郑宇赫必须在这末日般的环境中生存下去。他得到了一本神秘的《末日生存手册》，但这本手册的最后一页却写着："不要相信任何人。"',
    rating: 4.8,
    views: 890000,
    chapters: [
      { id: 'ch7-1', title: '第1话：病毒爆发', number: 1, updateDate: '2026-08-04', views: 55000 },
      { id: 'ch7-2', title: '第2话：生存法则', number: 2, updateDate: '2026-08-05', views: 42000 },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
    tags: ['动作', '末日', '生存', '悬疑'],
  },
  {
    id: 'comic-8',
    title: '花间集',
    author: '尹美京',
    category: '耽美',
    categoryId: 'bl',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20BL%20cover%20art%2C%20two%20handsome%20young%20men%20in%20traditional%20Korean%20hanbok%2C%20cherry%20blossom%20garden%20setting%2C%20soft%20pink%20and%20lavender%20color%20palette%2C%20romantic%20atmosphere%2C%20manhwa%20style%20illustration%2C%20delicate%20details%2C%20simple%20gradient%20background%2C%20digital%20art%2C%20high%20quality%20render&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '朝鲜时代，花郎道场的首席弟子李轩与来自异国的神秘画师相遇。两人在花间以画传情，在禁忌的时代中谱写了一段动人而曲折的爱情故事。',
    rating: 4.9,
    views: 750000,
    chapters: [
      { id: 'ch8-1', title: '第1话：花间初遇', number: 1, updateDate: '2026-08-03', views: 48000 },
      { id: 'ch8-2', title: '第2话：画中情意', number: 2, updateDate: '2026-08-05', views: 35000 },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
    tags: ['耽美', '古风', '艺术', '禁忌之恋'],
  },
  {
    id: 'comic-9',
    title: '格斗天王',
    author: '权泰宇',
    category: '动作',
    categoryId: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20cover%20art%2C%20martial%20artist%20in%20fighting%20stance%20with%20dynamic%20motion%20lines%2C%20bold%20orange%20and%20black%20color%20scheme%2C%20intense%20energy%2C%20manhwa%20style%20illustration%2C%20powerful%20composition%2C%20simple%20dark%20gradient%20background%2C%20digital%20art%2C%20high%20quality%20render&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '从小在街头长大的孤儿金泰洙，凭借着惊人的格斗天赋在地下拳场打出了名堂。但他的目标不仅仅是成为地下拳王，而是要站上世界格斗大赛的舞台，证明自己的价值。',
    rating: 4.6,
    views: 1100000,
    chapters: [
      { id: 'ch9-1', title: '第1话：街头之王', number: 1, updateDate: '2026-08-02', views: 72000 },
      { id: 'ch9-2', title: '第2话：地下拳场', number: 2, updateDate: '2026-08-04', views: 68000 },
      { id: 'ch9-3', title: '第3话：宿命的对手', number: 3, updateDate: '2026-08-05', views: 45000 },
    ],
    status: '连载中',
    updateDate: '2026-08-05',
    tags: ['动作', '格斗', '热血', '成长'],
  },
  {
    id: 'comic-10',
    title: '魔法学校的日常',
    author: '张瑞希',
    category: '搞笑',
    categoryId: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20comedy%20cover%20art%2C%20students%20in%20magic%20school%20uniforms%20with%20funny%20expressions%2C%20magical%20sparks%20around%2C%20bright%20purple%20and%20teal%20colors%2C%20playful%20atmosphere%2C%20manhwa%20style%20illustration%2C%20whimsical%20composition%2C%20simple%20gradient%20background%2C%20digital%20art%2C%20high%20quality%20render&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '在艾斯特拉魔法学院里，有一群天赋异禀但总是把事情搞砸的学生们。他们每天都在用魔法制造各种意外和笑料。这是一部关于魔法校园生活的搞笑日常漫画。',
    rating: 4.5,
    views: 720000,
    chapters: [
      { id: 'ch10-1', title: '第1话：入学典礼大混乱', number: 1, updateDate: '2026-08-01', views: 58000 },
      { id: 'ch10-2', title: '第2话：失败的变形术', number: 2, updateDate: '2026-08-03', views: 52000 },
    ],
    status: '连载中',
    updateDate: '2026-08-03',
    tags: ['搞笑', '魔法', '校园', '日常'],
  },
  {
    id: 'comic-11',
    title: '深海迷踪',
    author: '赵贤宇',
    category: '悬疑',
    categoryId: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20thriller%20cover%20art%2C%20diver%20descending%20into%20dark%20ocean%20depths%20with%20mysterious%20glow%20below%2C%20deep%20blue%20and%20teal%20color%20scheme%2C%20eerie%20atmosphere%2C%20manhwa%20style%20illustration%2C%20underwater%20scene%2C%20simple%20dark%20gradient%20background%2C%20digital%20art%2C%20high%20quality%20render&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '海洋考古学家沈海琳在一次深海勘探中，发现了一座沉没在海底的神秘古城遗迹。但随着调查的深入，她发现这座古城中隐藏着一个足以改变人类历史的惊天秘密。',
    rating: 4.7,
    views: 630000,
    chapters: [
      { id: 'ch11-1', title: '第1话：深海发现', number: 1, updateDate: '2026-07-29', views: 42000 },
      { id: 'ch11-2', title: '第2话：古城之谜', number: 2, updateDate: '2026-08-01', views: 38000 },
    ],
    status: '连载中',
    updateDate: '2026-08-01',
    tags: ['悬疑', '海洋', '考古', '科幻'],
  },
  {
    id: 'comic-12',
    title: '星尘恋曲',
    author: '安素英',
    category: '恋爱',
    categoryId: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20cover%20art%2C%20young%20couple%20lying%20under%20starry%20night%20sky%2C%20romantic%20atmosphere%2C%20deep%20purple%20and%20silver%20star%20color%20scheme%2C%20dreamy%20mood%2C%20manhwa%20style%20illustration%2C%20celestial%20theme%2C%20simple%20dark%20gradient%20background%2C%20digital%20art%2C%20high%20quality%20render&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '天文系学生崔星辰在观测星空时，遇到了一个自称来自外星的女孩。在与她的相处中，星辰发现自己竟然渐渐爱上了这个"外星人"。但当真相揭晓的那一刻，一切都将改变……',
    rating: 4.8,
    views: 580000,
    chapters: [
      { id: 'ch12-1', title: '第1话：流星之夜', number: 1, updateDate: '2026-07-26', views: 40000 },
      { id: 'ch12-2', title: '第2话：外星女孩', number: 2, updateDate: '2026-07-28', views: 38000 },
      { id: 'ch12-3', title: '第3话：星空下的约定', number: 3, updateDate: '2026-07-30', views: 36000 },
    ],
    status: '连载中',
    updateDate: '2026-07-30',
    tags: ['恋爱', '科幻', '校园', '治愈'],
  },
];

export function getComicById(id: string): Comic | undefined {
  return [...hotComics, ...latestUpdates].find(c => c.id === id);
}

export function getComicsByCategory(categoryId: string): Comic[] {
  if (categoryId === 'all') return [...hotComics, ...latestUpdates];
  return [...hotComics, ...latestUpdates].filter(c => c.categoryId === categoryId);
}

export function getRelatedComics(comicId: string, limit: number = 4): Comic[] {
  const comic = getComicById(comicId);
  if (!comic) return [];
  return [...hotComics, ...latestUpdates]
    .filter(c => c.id !== comicId && c.categoryId === comic.categoryId)
    .slice(0, limit);
}